import { useEffect, useMemo, useRef, useState } from 'react';
import { blueCheckmark } from '../config/icons';
import { Box, Collapse, Paper, Stack, SvgIcon, Typography, useTheme } from '@mui/material';
import { ShadowButton } from './shadow-button';
import { ProjectSpec } from '../types/config';
import { LandingSectionTitle } from './landing-section-title';

export const specCategory = {
  '0': 'כללי',
  '1': 'חדרי אמבטיה/שירותים ואינסטלציה',
  '2': 'מטבח',
  '3': 'מפרט',
  '7': 'דירה',
  '8': 'בניין',
  '9': 'פנטהאוז',
  '10': 'מגדל',
  '11': 'חיפויים',
  '12': 'כלים סניטאריים',
  '13': 'חשמל',
  '14': 'הסביבה',
  '15': 'פלורידה',
  '16': "ג'ורג'יה",
  '17': 'אינדיאנה',
  '18': 'דירת 4 חדרים',
  '19': 'דירת 5 חדרים',
  '20': 'פנטהאוז 5 חדרים',
  '21': 'חדרי רחצה',
  '22': 'חדרי שירותים ואמבטיה',
  '23': 'תוספות מיוחדות',
  '24': 'ממ"ד',
  '25': "קוטג'ים",
  '26': 'הדירה - 4 חדרים ודירת גן',
  '27': 'הדירה- 5 חדרים',
  '28': 'חבילת פלטיניום',
  '29': 'דירת גן + מרתף',
  '30': "30 דירת פנט - קוטג'",
  '31': 'לופטים',
  '32': 'דופלקסים',
  '33': 'מפרט ירוק',
  '34': 'דירות גג',
  '35': 'דירות גן',
  '36': 'דירות טיפוסיות במגדל / בניין',
  '37': 'עיקרי מפרט המגדל / הבניין',
  '38': '',
  '39': 'הבניין והשכונה',
  '40': 'חדרים רטובים',
  '41': 'בנייני המדורגים',
  '42': 'פנטהאוז - תמריר 4',
  '43': 'העיצוב הרומנטי',
  '44': 'העיצוב הקלאסי',
  '45': 'עיצוב פלטיניום Vip',
  '46': 'לובי',
  '47': 'שטח ציבורי',
  '48': 'ריצוף וכלים סניטריים',
  '49': 'גינה',
  '50': 'חשמל ותקשורת',
  '51': "פנים הקוטג'",
  '52': 'שירותים וחדרי אמבטיה',
  '53': 'מיזוג אויר',
  '54': 'ריצוף גרניט פורצלן איכותי במבחר גוונים 80x80 בחדר דיור ומטבח',
  '55': 'עיקרי המפרט הירוק',
  '56': 'אלומיניום ודלתות',
  '57': 'הבית וסביבתו',
  '58': 'אמבט ושירותים',
  '59': 'דלתות וחלונות',
  '60': 'ריצופים וחיפויים',
  '61': 'מרפסת שמש',
  '62': 'חלונות',
  '63': 'אלומיניום',
  '64': 'הפרויקט',
  '65': 'חדרי אמבטיה \\ יחידת הורים',
  '66': 'מטבח וחדרי רחצה',
  '67': 'מפרט פרימיום ייחודי ומפנק הכולל',
  '68': 'מתחם',
  '69': 'דירה - חדרי מגורים',
  '70': 'דירה - חדרי רחצה',
  '71': 'דירה - מטבח',
  '72': 'סלון, פינת אוכל, חדרי שינה',
  '73': 'חלונות ואלומיניום',
  '74': 'דלתות',
  '75': 'עיצוב פנים',
  '76': 'הבניין וסביבתו',
  '77': 'עיקרי מפרט טכני',
  '78': 'עיקרי המפרט הירוק',
  '79': 'מטבח וכלים סניטריים',
  '80': 'ריצוף',
  '81': 'ריצופים וחיפויים',
  '82': 'מסגרות, נגרות ואלומיניום',
  '83': 'ריצוף וחיפוי קירות',
  '84': 'בניין',
  '85': 'סוהו פרימיום',
  '86': 'בניין',
  '87': 'מטבח',
  '88': 'מרפסת',
  '89': 'חניות',
  '90': 'מטבח',
  '91': 'הקומפלקס',
  '92': 'השטחים הציבוריים',
  '93': '111',
  '94': 'מיזוג וחימום',
  '95': 'דלתות',
  '96': 'פתחי חוץ',
  '97': 'חלל חוץ',
  '98': 'חלונות, תריסים ודלתות',
  '99': 'שלב המדורגים',
  '100': 'מפרט ירוק',
  '101': 'חדרי רחצה',
  '102': '',
  '103': 'מיזוג',
  '104': '',
  '105': 'חשמל ותקשורת',
  '106': 'דלתות חלונות וריצוף',
  '107': 'מקלחת הורים',
  '108': 'חשמל ומיזוג',
  '109': 'סל שירותים',
  '110': 'חדר רחצה ושירותים',
  '111': 'מעקות',
  '112': 'מטבח וחדרי רחצה',
  '113': 'אלומניום, מעקות וחלונות',
  '114': 'כלים סניטריים ואינסטלציה',
  '115': 'אבזור',
};

const SPECS_MAX_HEIGHT = 360;

export type SpecsByCategoryItemProps = {
  title: string;
  values: string[];
};

export type SpecificationsProps = {
  specs: (ProjectSpec | string)[];
  t: (key: string) => string;
  fixedHeight?: boolean;
};

export function Specifications({ specs, t, fixedHeight = false }: SpecificationsProps) {
  const { palette } = useTheme();
  const specsRef = useRef<HTMLDivElement>(null);
  const [collapsedHeight] = useState(SPECS_MAX_HEIGHT);
  const [isCollapsible, setIsCollapsible] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(isCollapsible);
  const [isFixesHeight, setIsFixedHeight] = useState(false);

  const [specsByCategory, specsStrings] = useMemo(() => {
    const specsByCategory: SpecsByCategoryItemProps[] = [];
    const specsStrings: string[] = [];
    specs.forEach((s) => {
      // specs is array of string (treated as spec), or objects that hold specs.
      if (typeof s === 'object') {
        // first object property holds data, and is a category name,
        // from hardcoded number or provided string
        const [key, values] = Object.entries(s)[0];
        if (!values.length) return; // skip empty categories
        if (!isNaN(Number(key))) {
          //@ts-ignore
          const categoryName = specCategory[key];
          specsByCategory.push({
            title: categoryName,
            values,
          });
        } else {
          specsByCategory.push({
            title: key,
            values,
          });
        }
      }
      if (typeof s === 'string') {
        specsStrings.push(s);
      }
    });
    return [specsByCategory, specsStrings];
  }, [specs]);

  // Calculate the height of the collapsed specs
  useEffect(() => {
    if (specsRef.current) {
      if (fixedHeight && isFixesHeight) return;
      const specsHeight = Number(specsRef.current?.clientHeight) || 0;
      setIsCollapsible(specsHeight > collapsedHeight);
      setIsCollapsed(specsHeight > collapsedHeight);
      fixedHeight && setIsFixedHeight(true);
    }
  }, [specsByCategory, specsStrings]);

  // // collapse depending on specs amount
  // useEffect(() => {
  //   if (specsRef.current && collapsedHeight === 0 && isCollapsible) {
  //     const specsDomEls = specsRef.current.querySelectorAll('.spec');
  //     const height = [...specsDomEls].slice(0, SPECS_LINES_TO_SHOW).reduce((acc, spec) => acc + spec.clientHeight, 0);
  //     setCollapsedHeight(height);
  //   }
  // }, [collapsedHeight, specsByCategory, specsStrings, isCollapsible]);

  return (
    <Stack
      direction="column"
      width="100%"
      spacing={'10px'}
      sx={{ padding: { xs: '0 16px', sm: '0' } }}
    >
      <Stack direction="column" spacing={{ xs: '20px', sm: '24px' }}>
        <LandingSectionTitle
          title={t('labels.specifications')}
          subtitle={t('info.specificationsDescription')}
        />

        <Collapse ref={specsRef} in={!isCollapsed} collapsedSize={collapsedHeight}>
          <Stack direction="column" spacing={{ xs: '10px' }}>
            {specsByCategory.map((sc, index) => (
              <Paper
                key={index}
                elevation={1}
                sx={{
                  padding: '20px',
                  border: '1px solid #EAECF0',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  width: '100%',
                }}
              >
                <Typography fontWeight={600} gutterBottom>
                  {sc.title}
                </Typography>
                {sc.values.map((spec, i) => (
                  <Stack
                    key={i}
                    className="spec"
                    direction="row"
                    spacing={2}
                    py="4px"
                    alignItems="center"
                  >
                    <SvgIcon
                      sx={{
                        width: { xs: '20px', sm: '24px' },
                      }}
                    >
                      {blueCheckmark}
                    </SvgIcon>
                    <Typography>{spec}</Typography>
                  </Stack>
                ))}
              </Paper>
            ))}

            {!!specsStrings.length && (
              <Paper
                elevation={1}
                sx={{
                  padding: '20px',
                  border: '1px solid #EAECF0',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  width: '100%',
                }}
              >
                {specsStrings.map((spec, idx) => (
                  <Stack
                    key={idx}
                    className="spec"
                    direction="row"
                    spacing={2}
                    py="4px"
                    alignItems="center"
                  >
                    <SvgIcon
                      sx={{
                        width: { xs: '20px', sm: '24px' },
                      }}
                    >
                      {blueCheckmark}
                    </SvgIcon>
                    <Typography>{spec}</Typography>
                  </Stack>
                ))}
              </Paper>
            )}
          </Stack>
        </Collapse>
      </Stack>

      {isCollapsible && (
        <Box sx={{ position: 'relative' }}>
          {isCollapsed && (
            <Box
              sx={{
                position: 'absolute',
                top: '-50px',
                left: 0,
                right: 0,
                height: '40px',
                background: `linear-gradient(to bottom, transparent, ${palette.grey[50]})`,
                pointerEvents: 'none',
              }}
            />
          )}
          <ShadowButton
            label={isCollapsed ? t('labels.readMore') : t('labels.readLess')}
            onClick={() => setIsCollapsed((prev) => !prev)}
          />
        </Box>
      )}
    </Stack>
  );
}
